import { Methods } from '../../api/methods.js';
import type { ParsedArgs } from '../args.js';
import { flag } from '../args.js';
import { CliError, ExitCode } from '../errors.js';
import type { CommandResult } from '../output.js';
import { request, requireConfirmation } from './common.js';

export async function backupCommand(args: ParsedArgs): Promise<CommandResult> {
  const action = args.positionals[1] ?? 'status';
  switch (action) {
    case 'create':
      return request(args, Methods.SettingsBackup);
    case 'list':
      return request(args, Methods.SettingsBackupList);
    case 'inspect':
      return request(args, Methods.SettingsBackupInspect, { name: requiredValue(args, 'name') });
    case 'delete': {
      const name = requiredValue(args, 'name');
      requireConfirmation(args, 'Deleting a backup requires confirmation');
      return request(args, Methods.SettingsBackupDelete, { name });
    }
    case 'restore': {
      const name = requiredValue(args, 'name');
      requireConfirmation(args, 'Restoring a backup requires confirmation');
      return request(args, Methods.SettingsBackupRestore, { name });
    }
    case 'status':
      return request(args, Methods.SettingsBackupStatus);
    case 'remote-run':
      return request(args, Methods.SettingsBackupRemoteRun);
    case 'remote-list':
      return request(args, Methods.SettingsBackupRemoteList);
    case 'remote-restore': {
      const id = requiredValue(args, 'id');
      requireConfirmation(args, 'Restoring a remote backup requires confirmation');
      return request(args, Methods.SettingsBackupRemoteRestore, { id });
    }
    default:
      throw new CliError(`Unknown backup action "${action}"`, ExitCode.Usage);
  }
}

function requiredValue(args: ParsedArgs, flagName: string): string {
  const value = args.positionals[2] ?? flag(args.flags, flagName);
  if (!value) throw new CliError(`backup action requires <${flagName}>`, ExitCode.Usage);
  return value;
}
